import React, { Component } from "react";
import { ReactComponent as Logo } from "./dsa.svg";

export default class DesignImg extends Component {
  render() {
    // const theme = this.props.theme;
    return <Logo />;
  }
}
